import React from 'react';
import styles from './TextEffectsShared.scss';

export const createSvgManager = (svgContent: string) => {
  let svgElement: SVGElement | null = null;
  let svgReferenceCount = 0;

  const removeSvgReference = () => {
    if (svgReferenceCount > 0) {
      svgReferenceCount--;
    }

    if (svgReferenceCount === 0 && svgElement) {
      document.body.removeChild(svgElement);
    }
  };

  return {
    addSvgReference: () => {
      svgReferenceCount++;

      if (svgReferenceCount > 1) {
        return removeSvgReference;
      }

      svgElement = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'svg',
      );
      svgElement.setAttribute('class', styles.visuallyHidden);
      svgElement.innerHTML = svgContent;
      document.body.appendChild(svgElement);

      return removeSvgReference;
    },
  };
};

const useUniqueSvg = (svgManager: ReturnType<typeof createSvgManager>) => {
  React.useEffect(() => {
    const removeSvgReference = svgManager.addSvgReference();
    return removeSvgReference;
  }, [svgManager]);
};

export default useUniqueSvg;
